export default __webpack_public_path__ + "static/media/the_chariot.6610cda2.png";